import { LanguageAtom } from "shared/helpers/language";
import { client } from "shared/helpers/client";
import { useSetRecoilState } from "recoil";
import { useMutation, useQuery } from "react-query";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import React from "react";
import { useLookups } from "shared/hooks/use-lookups";

interface PreferencesDataResponse {
  languageId: number;
  defaultFilterPeriodId: number;

}

interface PreferencesData {
  languageId: number;
  defaultFilterPeriodId: number;
  
}

export function usePreferences() {
  const { t } = useTranslation();
  const setLocalLanguage = useSetRecoilState(LanguageAtom);

const {languages,periods} = useLookups(['languages','periods'])
  const { data: ownerPerfrences } = useQuery(
    ["owner-perfrences"],
    () =>
    client<PreferencesDataResponse>("Owner/GetOwnerPreferences").then((r) => r.response),
    {
      onSuccess(companyInfo) {
        methods.reset({
          languageId: companyInfo?.languageId,
          defaultFilterPeriodId: companyInfo?.defaultFilterPeriodId,
       
        });
      },
    }
  );
  const preferencesForm = useForm({
    resolver:yupResolver(yup.object().shape({
      languageId:yup.number(),
      defaultFilterPeriodId:yup.number(),
    }))
  });
  
  const schema = React.useMemo(() => {
    return yup.object().shape({
      languageId: yup.number().required(t('errors.required')),
      defaultFilterPeriodId: yup.number().required(t('errors.required')),

    });
  }, [t]);
  
  const methods = useForm<PreferencesData>({
    resolver: yupResolver(schema),
    defaultValues: {
      languageId: 0,
      defaultFilterPeriodId: 0,
    },
  });

  const { mutate: callChangeCompanyInfoServer ,isLoading} = useMutation((companyData: any) =>
    client("/Owner/UpdateOwnerPreference", { data: companyData})
  );




  async function changeCompanyInfo(data: PreferencesData) {
    // TODO: Add Files
    const InfoDto = {
      languageId: data.languageId,
      defaultFilterPeriodId:data.defaultFilterPeriodId,
    };

    callChangeCompanyInfoServer(InfoDto, {
      onSuccess({ response, error }) {
        
        if (response) {
          let langCode = InfoDto?.languageId === 1 ? 'ar' : 'en'
          setLocalLanguage(langCode)
          toast.success(t("form.save-success"));
        }
       // if (error) toast.error(t("errors.server-error"));
      },
    });
  }

  return {
    preferencesForm,
    ownerPerfrences,
    ...methods,
    isLoading,
    changeCompanyInfo,
    languages,
    periods,
  };
}